module.exports = __webpack_public_path__ + "img/ferrari.389756b8.png";